module.exports = __webpack_public_path__ + "static/img/pro2.3839f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/pro2.png
// module id = KQxF
// module chunks = 0